import './content-loader.scss';

import { Spinner } from '../spinner/spinner';

type ContentLoaderProps = {
  message?: JSX.Element | string;
};

export function ContentLoader({ message }: ContentLoaderProps) {
  return (
    <div className="content-loader">
      <div className="content-loader__content">
        <p>
          <Spinner />
          {message}
        </p>
      </div>
    </div>
  );
}
